//
// clarification: session duration includes timer duration, it doesn't sum up.
//

// Session duration (in minutes)
const DEFAULT_SESSION_DURATION = 30;

// Time to display timer before session expires (in minutes)
export const TIMER_DURATION = 5;

// Count time to display timer based on session duration (in ms)
export const countTimeToDisplayTimer = (sessionDurationMinutes) =>
    (sessionDurationMinutes - TIMER_DURATION) * 60 * 1000;

// Computed length of default time to display timer (in ms)
export const DEFAULT_TIME_TO_DISPLAY_TIMER = countTimeToDisplayTimer(DEFAULT_SESSION_DURATION);
